// @flow

import paths from "./paths";

export const links = [
  {
    path: paths.bankInquiriesListNew,
    label: "Bankanfragen"
  },
  {
    path: paths.customerInquiriesList,
    label: "Kundenanfragen"
  },
  {
    path: paths.userData,
    label: "Meine Daten"
  }
];

export const customerInquiryTabs = (bankOfferId = null) => [
  {
    label: "Dashboard",
    path: paths.customerInquiryDashboard(bankOfferId)
  },
  {
    label: "Unterlagenaustausch",
    path: paths.customerInquiryDocuments(bankOfferId)
  },
  {
    label: "Ursprungsdaten",
    path: paths.customerInquiryDetails(bankOfferId)
  }
];

export const bankInquiryTabs = (inquiryId = null) => [
  {
    label: "Dashboard",
    path: paths.bankInquiryDashboard(inquiryId)
  },
  {
    label: "Unterlagenaustausch",
    path: paths.bankInquiryDocuments(inquiryId)
  },
  {
    label: "Ursprungsdaten",
    path: paths.bankInquiryDetails(inquiryId)
  }
];

export const bankInquiryTabsNew = (inquiryId: number, financingProcess: any) => {
  const tabs = [
    {
      label: "Dashboard",
      path: paths.bankInquiryDashboardNew(inquiryId)
    },
    {
      label: "Unterlagenaustausch",
      path: paths.bankInquiryDocumentsNew(inquiryId)
    },
    {
      label: "Ursprungsdaten",
      path: paths.bankInquiryDetailsNew(inquiryId)
    }
  ];

  if (financingProcess?.fidesMetadata?.dataAvailable) {
    tabs.push({
      label: "Antrag",
      path: paths.bankInquiryApplication(inquiryId)
    });
  }

  return tabs;
};
